(function () {
  const U = window.UIX;
  const APP = window.APP;
  const el = U.el;
  const esc = U.esc;

  const SOURCES = [["all", "All"], ["starred", "Starred"], ["yours", "Yours"], ["metagame", "Metagame"], ["precon", "Precon"]];
  const SOURCE_LABEL = { yours: "Yours", metagame: "Metagame", precon: "Precon" };
  const CLOSE = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round'><path d='M6 6l12 12M18 6L6 18'></path></svg>";
  const SEARCH = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round'><circle cx='11' cy='11' r='7'></circle><path d='M20 20l-3.5-3.5'></path></svg>";
  const MINI_CURVE = 22;

  const P = { seat: null, title: "", search: "", source: "all", runes: {}, sig: null, keep: 0, caret: null, focus: false };

  function sourceOf(deck) {
    return deck.library ? "metagame" : deck.builtin ? "precon" : "yours";
  }

  function eventLine(deck) {
    const ev = deck.event;
    if (!ev || typeof ev !== "object") return "";
    const bits = [];
    if (ev.name) bits.push(ev.name);
    if (ev.date) bits.push(ev.date);
    if (ev.placement) bits.push(ordinal(ev.placement));
    return bits.join(" · ");
  }

  function ordinal(n) {
    const v = Number(n);
    if (!v) return String(n);
    const s = ["th", "st", "nd", "rd"];
    const m = v % 100;
    return v + (s[(m - 20) % 10] || s[m] || s[0]);
  }

  function haystack(deck) {
    const legend = U.deckLegend(deck);
    const champ = U.deckChampion(deck);
    return [deck.name, legend ? legend.name : "", champ ? champ.name : "", eventLine(deck), deck.tagline || ""].join(" ").toLowerCase();
  }

  function decksSorted() {
    const favs = RB.Decklists.favorites();
    const rank = { yours: 0, metagame: 1, precon: 2 };
    const all = RB.Decklists.all().map(function (d) {
      return { deck: d, source: sourceOf(d), fav: favs.indexOf(d.id) >= 0, key: haystack(d) };
    });
    all.sort(function (a, b) {
      if (a.fav !== b.fav) return a.fav ? -1 : 1;
      if (rank[a.source] !== rank[b.source]) return rank[a.source] - rank[b.source];
      if (a.source === "metagame") {
        const da = (a.deck.event && a.deck.event.date) || "";
        const db = (b.deck.event && b.deck.event.date) || "";
        if (da !== db) return da < db ? 1 : -1;
        const pa = (a.deck.event && a.deck.event.placement) || 999;
        const pb = (b.deck.event && b.deck.event.placement) || 999;
        if (pa !== pb) return pa - pb;
      }
      return a.deck.name.localeCompare(b.deck.name);
    });
    return all;
  }

  function pickedDomains() {
    const picked = [];
    for (const dom in P.runes) if (P.runes[dom]) picked.push(dom);
    return picked;
  }

  function filtered(all) {
    const picked = pickedDomains();
    const q = P.search.trim().toLowerCase().split(/\s+/).filter(function (w) { return w; });
    return all.filter(function (e) {
      if (P.source === "starred" && !e.fav) return false;
      if (P.source !== "all" && P.source !== "starred" && e.source !== P.source) return false;
      if (picked.length) {
        const doms = U.deckDomains(e.deck);
        if (!picked.every(function (d) { return doms.indexOf(d) >= 0; })) return false;
      }
      for (const w of q) if (e.key.indexOf(w) < 0) return false;
      return true;
    });
  }

  function miniCurve(deck) {
    const bars = U.deckCurve(deck).bars;
    const peak = U.peakOf(bars);
    const strip = el("span", "pldcurve");
    for (const n of bars) {
      const b = el("i", "pldcb");
      b.style.height = Math.max(2, Math.round((n / peak) * MINI_CURVE)) + "px";
      strip.appendChild(b);
    }
    strip.title = "Energy curve, 1 to 7+";
    return strip;
  }

  function deckRow(deck, opts) {
    const o = opts || {};
    const errs = U.blockingErrs(deck);
    const legend = U.deckLegend(deck);
    const champ = U.deckChampion(deck);
    const source = sourceOf(deck);
    const row = el("div", "pldrow" + (o.current ? " cur" : ""));

    const thumb = el("span", "pldthumb");
    if (legend || champ) thumb.appendChild(U.artImg(legend || champ, "", { sizes: "60px" }));
    row.appendChild(thumb);

    const runes = el("span", "pldruns");
    for (const dom of U.deckDomains(deck)) {
      const card = RB.Setup.findCard(RB.Decklists.RUNE_CARDS[dom]);
      const cell = el("span", "pldrune");
      cell.title = dom;
      if (card) cell.appendChild(U.artImg(card, "", { sizes: "30px" }));
      runes.appendChild(cell);
    }
    row.appendChild(runes);

    const main = el("span", "pldmain");
    main.appendChild(el("span", "pldname", esc(deck.name)));
    const who = (legend ? legend.name : "no legend") + " · " + (champ ? champ.name : "no champion");
    const date = deck.event && deck.event.date ? deck.event.date + " · " : "";
    main.appendChild(el("span", "pldsub", esc(source === "metagame" ? date + who : who)));
    row.appendChild(main);

    row.appendChild(miniCurve(deck));

    if (o.star) row.appendChild(U.starButton(deck, "pldstar", "Unstar", "Star"));

    row.appendChild(el("span", "pldsrc", esc(SOURCE_LABEL[source])));
    const dot = el("span", "pldot " + (errs.length ? "bad" : "ok"));
    dot.title = errs.length ? errs.join(" · ") : "Tournament legal";
    row.appendChild(dot);
    return row;
  }

  function openDrawer(seat, title) {
    P.seat = seat;
    P.title = title || "";
    P.search = "";
    P.source = "all";
    P.runes = {};
    P.sig = null;
    P.keep = 0;
    P.caret = null;
    P.focus = true;
    U.render();
  }

  function closeDrawer() {
    if (!P.seat) return;
    P.seat = null;
    APP.ring = null;
    U.render();
  }

  function drawerOpen(seat) {
    return P.seat === seat;
  }

  function reRender(keepFocus) {
    const list = document.querySelector("#playscreen .pldrawlist");
    P.keep = list ? list.scrollTop : 0;
    P.focus = keepFocus !== false;
    U.render();
  }

  function restoreDrawer() {
    if (!P.seat) return;
    const list = document.querySelector("#playscreen .pldrawlist");
    const sig = P.source + "\u0000" + P.search + "\u0000" + pickedDomains().join(",");
    if (list) {
      if (sig === P.sig) list.scrollTop = P.keep;
      else {
        const cur = list.querySelector(".pldrow.cur");
        if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: "center" });
      }
    }
    P.sig = sig;
    if (P.focus) {
      P.focus = false;
      const field = document.getElementById("dpsearchfield");
      if (field) {
        const at = P.caret === null ? field.value.length : Math.min(P.caret, field.value.length);
        P.caret = null;
        field.focus();
        field.setSelectionRange(at, at);
      }
    }
  }

  function choose(seat, cfg, id) {
    const index = seat === "you" ? 0 : 1;
    cfg.seats[index].deck = id;
    U.saveMenuCfg(cfg);
    P.seat = null;
    APP.ring = null;
    U.render();
  }

  function drawer(seat, cfg) {
    const current = cfg.seats[seat === "you" ? 0 : 1].deck;
    const all = decksSorted();
    const shown = filtered(all);
    const counts = { all: all.length, starred: 0, yours: 0, metagame: 0, precon: 0 };
    for (const e of all) {
      counts[e.source]++;
      if (e.fav) counts.starred++;
    }

    const box = el("div", "pldrawer");
    const head = el("div", "pldrawhead");
    head.appendChild(el("span", "pldrawt", esc(P.title || "Choose a deck")));
    head.appendChild(el("span", "plribline"));
    head.appendChild(el("span", "pldrawn", esc(shown.length + (shown.length === 1 ? " deck" : " decks"))));
    const close = el("button", "plhb sm ico", CLOSE);
    close.type = "button";
    close.title = "Close";
    close.onclick = closeDrawer;
    head.appendChild(close);
    box.appendChild(head);

    const tools = el("div", "pldrawtools");
    const search = el("div", "pldsearch", SEARCH);
    search.appendChild(U.searchField({
      type: "search",
      id: "dpsearchfield",
      placeholder: "Search by deck, legend, champion or event…",
      value: P.search,
      refocus: false,
      onInput: function (value, caret) {
        P.search = value;
        P.caret = caret;
        reRender();
      },
      onKeydown: function (e) {
        if (e.key === "Escape") { e.preventDefault(); closeDrawer(); return; }
        if (e.key === "Enter" && shown.length) { e.preventDefault(); choose(seat, cfg, shown[0].deck.id); }
      },
    }));
    tools.appendChild(search);

    const tabs = el("div", "pldtabs");
    for (const src of SOURCES) {
      (function (src) {
        const b = el("button", "pldtab" + (P.source === src[0] ? " on" : ""),
          (src[0] === "starred" ? U.STAR_OFF : "") + "<span>" + esc(src[1]) + "</span><i>" + counts[src[0]] + "</i>");
        b.type = "button";
        b.onclick = function () { P.source = src[0]; reRender(false); };
        tabs.appendChild(b);
      })(src);
    }
    tools.appendChild(tabs);

    const picked = pickedDomains();
    const runeset = el("div", "pldrunes");
    for (const dom of RB.Core.DOMAINS) {
      (function (dom) {
        const card = RB.Setup.findCard(RB.Decklists.RUNE_CARDS[dom]);
        const cell = el("button", "pldrune pick" + (picked.length && !P.runes[dom] ? " off" : ""));
        cell.type = "button";
        cell.title = dom;
        if (card) cell.appendChild(U.artImg(card, "", { sizes: "30px" }));
        cell.onclick = function () { P.runes[dom] = !P.runes[dom]; reRender(false); };
        runeset.appendChild(cell);
      })(dom);
    }
    tools.appendChild(runeset);
    box.appendChild(tools);

    const list = el("div", "pldrawlist");
    if (!shown.length) list.appendChild(el("div", "plempty", "No deck matches those filters."));
    let lastGroup = null;
    for (const e of shown) {
      const grp = e.fav && P.source !== "starred" ? "starred" : e.source;
      if (grp !== lastGroup) {
        lastGroup = grp;
        list.appendChild(el("span", "plslbl",
          esc(grp === "starred" ? "Starred" : grp === "precon" ? "Preconstructed" : SOURCE_LABEL[grp]) +
          "<span class='plsline'></span>"));
      }
      (function (e) {
        const row = deckRow(e.deck, { current: e.deck.id === current, star: true });
        row.onclick = function () { choose(seat, cfg, e.deck.id); };
        row.ondblclick = function () { choose(seat, cfg, e.deck.id); };
        list.appendChild(row);
      })(e);
    }
    box.appendChild(list);
    return box;
  }

  Object.assign(U, {
    openDeckDrawer: openDrawer,
    closeDeckDrawer: closeDrawer,
    deckDrawerOpen: drawerOpen,
    deckDrawer: drawer,
    restoreDeckDrawer: restoreDrawer,
    deckRow: deckRow,
  });
})();
